<template>
  <v-card class="mb-7">
    <validation-observer ref="observer">
      <v-form>
        <v-card-text class="pa-5 border-bottom">
          <dados-info-geral @verificarBlackList="verificarBlackList" />
          <dados-pedido
            v-if="is_default || freepassComPedido"
            ref="dadosPedido"
          />
          <dados-veiculo @verificarBlackList="verificarBlackList" />
          <dados-motorista />
          <dados-remetente-destinatario v-if="is_default" />
          <dados-observacao v-if="is_default" />
          <dados-extra :extra_fields="extra_fields" />
        </v-card-text>
      </v-form>
    </validation-observer>
  </v-card>
</template>

<script>
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

import DadosInfoGeral from './DadosInfoGeral.vue'
import DadosPedido from './DadosPedido.vue'
import DadosVeiculo from './DadosVeiculo.vue'
import DadosMotorista from './DadosMotorista.vue'
import DadosRemetenteDestinatario from './DadosRemetenteDestinatario.vue'
import DadosObservacao from './DadosObservacao.vue'
import DadosExtra from './DadosExtra/Componente.vue'

import PatioAPI from '@/services/patio'

import { mapActions, mapState } from 'vuex'

export default {
  components: {
    DadosInfoGeral,
    DadosPedido,
    DadosVeiculo,
    DadosMotorista,
    DadosObservacao,
    DadosRemetenteDestinatario,
    DadosExtra,
  },
  computed: {
    ...mapState('agendamentos', ['agendamento']),
    freepassComPedido() {
      return (
        this.agendamento.tipo_documento == 'FP' &&
        this.config_fornecedor.freepassComPedido
      )
    },
    is_default() {
      return ['NF', 'OC', 'VR', 'TI', 'TE', 'NA'].includes(
        this.agendamento.tipo_documento
      )
    },
    config_fornecedor() {
      if (!this.agendamento) return {}
      if (!this.agendamento.fornecedor) return {}
      if (!('config' in this.agendamento.fornecedor)) return {}
      if (!('agendamento' in this.agendamento.fornecedor.config)) return {}
      return this.agendamento.fornecedor.config.agendamento
    },
    extra_fields_fornecedor() {
      if (!this.agendamento) return {}
      if (!this.agendamento.fornecedor) return {}
      if (!('extra_fields' in this.agendamento.fornecedor)) return {}
      if (!('agendamento' in this.agendamento.fornecedor.extra_fields))
        return {}
      return this.agendamento.fornecedor.extra_fields.agendamento
    },
    extra_fields() {
      return {
        fornecedor: this.extra_fields_fornecedor,
      }
    },
  },
  name: 'EtapaAgendamento',
  methods: {
    ...mapActions('patio', [
      'getModalidades',
      'getCarrocerias',
      'getTipoOperacao',
      'getTiposFrete',
    ]),

    ...mapActions('template', ['errorMessage']),
    handleErrorBlacklist(error) {
      if ('Transportador' in error) {
        this.agendamento.transportadora = null
      }
      if ('Motorista' in error) {
        Object.assign(this.agendamento.motorista, {
          public_id: '',
        })
        Object.assign(this.agendamento.motorista.user, {
          id: '',
          cpf: '',
          name: '',
          celular: '',
          cnh_registro: '',
        })
      }
      if ('Veiculo' in error) {
        Object.assign(this.agendamento.veiculo, {
          id: '',
          placa_cavalo: '',
          placa_carreta_1: '',
          placa_carreta_2: '',
          carroceria: '',
        })
        Object.assign(this.agendamento.modalidade, {
          eixo: '',
          id: '',
          descricao: '',
        })
        Object.assign(this.agendamento.conjunto, {
          carreta_1: '',
          carreta_2: '',
          carreta_3: '',
          dolly: '',
        })
      }
    },
    async verificarBlackList() {
      try {
        await PatioAPI.verificarBlackList(this.agendamento)
      } catch (error) {
        if (error.response && error.response.status === 400) {
          this.errorMessage(error.response ? error.response.data : error)
          this.handleErrorBlacklist(error.response.data)
        }
      }
    },
    async sendDocs() {
      if (this.is_default) {
        await this.$refs.dadosPedido.sendDocs()
      }
    },
    async validate() {
      await this.$refs.observer.validate()
      const fields_motorista = ['Documento', 'celular', 'registro da CNH']
      const fields_veiculo = [
        'nome',
        'Placa do Cavalo',
        'estados',
        'placa da carreta',
        'modalidade',
        'carroceria',
      ]
      // const isValid = !this.$refs.observer.flags.invalid
      let isValid = true
      const fields_exclude = [...fields_motorista, ...fields_veiculo]
      Object.keys(this.$refs.observer.errors).forEach((field) => {
        if (!fields_exclude.includes(field)) {
          if (this.$refs.observer.errors[field].length > 0) {
            isValid = false
          }
        }
      })
      return isValid
    },

    async atualizarListaTipoOperacao() {
      try {
        await this.getTipoOperacao()
      } catch (error) {
        if (error.response && error.response.status == 404) {
          this.errorMessage('Empresa não é um gate.')
        } else {
          this.errorMessage('Ocorreu algum erro inesperado.')
        }
      }
    },

    async atualizarListaModalidade() {
      try {
        await this.getModalidades()
      } catch (error) {
        if (error.response && error.response.status == 404) {
          this.errorMessage('Empresa não é um gate.')
        } else {
          this.errorMessage('Ocorreu algum erro inesperado.')
        }
      }
    },

    async atualizarListaCarrocerias() {
      try {
        await this.getCarrocerias()
      } catch (error) {
        if (error.response && error.response.status == 404) {
          this.errorMessage('Empresa não é um gate.')
        } else {
          this.errorMessage('Ocorreu algum erro inesperado.')
        }
      }
    },
  },
  async created() {
    await this.atualizarListaTipoOperacao()
    await this.atualizarListaModalidade()
    await this.atualizarListaCarrocerias()
    await this.getTiposFrete()
  },
}
</script>
